// Terms of Service version management
// Update this version number whenever you make changes to the terms
// Format: YYYY.MM.DD or semantic versioning (1.0.0, 1.1.0, etc.)

export const CURRENT_TERMS_VERSION = '1.2';

// Change log for transparency. Add entries here only when you publish a new terms version (post-launch).
export const TERMS_CHANGELOG: Record<string, { date: string; changes: string[] }> = {
  '1.2': {
    date: '2. mars 2026',
    changes: [
      'Punkt 1.1: Ny seksjon om personvern med lenke til Personvernerklæring',
      'Punkt 2.2: Alderskrav 18 år for betalte tjenester (Pluss-abonnement)',
      'Punkt 5.7: Nytt angrerett-formulering i tråd med Angrerettloven § 22 bokstav n',
      'Punkt 11: Tillegg om unntak for forsett og grov uaktsomhet',
    ],
  },
};

// Get changes for a specific version
export function getVersionChanges(version: string): string[] {
  return TERMS_CHANGELOG[version as keyof typeof TERMS_CHANGELOG]?.changes || [];
}
